module.exports = __webpack_public_path__ + "static/productsBG.35de30b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productsBG.jpg
// module id = 850
// module chunks = 82539731189068